import { useEffect, useState } from 'react';

import { CollectionFlowForm } from '@playbooks/components/collection/collection-flow-form';
import { CollectionFlowSelect } from '@playbooks/components/collection/collection-flow-select';
import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';

const CollectionFlow = ({ model, open, setOpen, rootApi, onNext }) => {
	const [selected, setSelected] = useState([]);
	const [view, setView] = useState('select');

	// Computed
	const data = { bookmarks: [{ id: model.id }] };

	// Hooks
	useEffect(() => {
		if (open) setSelected(model.collections || []);
	}, [open]);

	useEffect(() => {
		if (open) setView('select');
	}, [open]);

	// Methods
	const onClose = () => {
		setOpen(false);
	};

	const onFinish = data => {
		setSelected(selected.concat(data));
		setView('select');
	};

	// Render
	return (
		<Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DialogContent variant='form'>
				{view === 'select' && (
					<CollectionFlowSelect
						model={model}
						selected={selected}
						setSelected={setSelected}
						onView={setView}
						onClose={onClose}
						onNext={onNext}
					/>
				)}
				{view === 'form' && (
					<CollectionFlowForm
						model={{ name: '', description: '', ...data }}
						onClose={onClose}
						onPrev={() => setView('select')}
						onNext={onFinish}
					/>
				)}
			</DialogContent>
		</Dialog>
	);
};

export { CollectionFlow };
